<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label class="text-info" v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           autocomplete="false"
           v-mask="'99/99/9999'"
           :value="value || false"
           @input="updateValue($event.target.value)"
           @blur="updateValue($event.target.value)"
           @change="updateValue($event.target.value)"
           :name="name"
           :required="required"
           :placeholder="placeholder"
           class="form-control"
           :class="additionalClass"
           :id="id"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputDate',
    props: [
      'name',
      'id',
      'startId',
      'endId',
      'value',
      'minDate',
      'maxDate',
      'minPeriod',
      'weekendDisabled',
      'required',
      'label',
      'placeholder',
      'error',
      'additionalClass'
    ],
    components: {},
    data () {
      return {}
    },
    mounted () {
      this.setData()
    },
    methods: {
      setData () {
        let self = this
        let config = {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          debug: false
        }
        if (this.minDate) {
          switch (this.minDate) {
            case 'today':
              config.minDate = window.moment()
              break
            case 'yesterday':
              config.minDate = window.moment().subtract(1, 'd')
              break
            case 'tomorrow':
              config.minDate = window.moment().add(1, 'd')
              break
            default:
              config.minDate = window.moment(this.minDate, 'DD/MM/YYYY')
          }
        }
        if (this.maxDate === 'today') {
          config.maxDate = window.moment()
        }
        /*
        if (config.minDate) {
          if (config.minDate.weekday() === 7) {
            config.minDate = config.minDate.add(1, 'd')
          }
          if (config.minDate.weekday() === 6) {
            config.minDate = config.minDate.add(2, 'd')
          }
        }
        if (config.maxDate) {
          if (config.maxDate.weekday() === 7) {
            config.maxDate = config.maxDate.add(1, 'd')
          }
          if (config.maxDate.weekday() === 6) {
            config.maxDate = config.maxDate.add(2, 'd')
          }
        }
        */
        if (this.weekendDisabled) {
          config.daysOfWeekDisabled = [0, 6]
        }
        window.$('#' + this.id, this.$el)
        .datetimepicker(config)
        .on('dp.change', (e) => {
          self.updateValue(window.moment(e.date).format('DD/MM/YYYY'))
          if (self.endId) window.$('#' + self.endId).data('DateTimePicker').minDate(e.date)
          if (self.startId) window.$('#' + self.startId).data('DateTimePicker').maxDate(e.date)
        })
        this.updateValue(window.$('#' + this.id, this.$el)[0].value)
      },
      updateValue (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputDate.vue?1b407d3d